import React from 'react';
import { Box, Stack, Typography, Tooltip } from '@mui/material';

// กลุ่มสถานะ radio-style — คลิกเพื่อเลือก/ยกเลิก (เหมือนแท็บ "สถานภาพ" เดิม)
// warnEmpty: ขึ้นแดงเตือนถ้ายังไม่ได้เลือกอะไรเลย (currentKey ว่าง) — ใช้กับช่องที่ต้องบังคับให้ user ตัดสินใจ
// dangerBg: บังคับกล่องทั้งใบ (กรอบ/แถบข้าง/ตัวหนา/พื้นหลัง) เป็นสีแดงแทนสีเฉพาะของแต่ละกลุ่ม
// (blue/orange/purple ฯลฯ) — ใช้ตอนโปรเจกต์มีคดีฟ้องร้อง ให้ทั้ง sidebar เป็นสีแดงเป็นเนื้อเดียวกัน
// ไม่ใช่แค่พื้นหลังรอบนอกกล่อง (ของเดิมกล่องแต่ละใบทึบสีตัวเองทับพื้นหลังหน้าไว้อยู่แล้ว)
export function StatusGroup({ title, color, options, currentKey, onSelect, warnEmpty, getOptionDisabledReason, dangerBg }) {
  const isEmpty = warnEmpty && !currentKey;
  const effectiveColor = isEmpty || dangerBg ? '#dc2626' : color;
  return (
    <Box
      sx={{
        p: 0.65,
        borderRadius: 1.5,
        border: '1px solid',
        borderColor: `${effectiveColor}${isEmpty ? '80' : '28'}`,
        boxShadow: `inset 3px 0 0 ${effectiveColor}`,
        bgcolor: isEmpty || dangerBg ? '#fef2f2' : '#fafbff',
        mb: 0.6,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          fontWeight: 700,
          fontSize: '0.67rem',
          color: effectiveColor,
          mb: 0.3,
          pb: 0.15,
          borderBottom: `1px solid ${effectiveColor}25`,
        }}
      >
        {title}
        {isEmpty && ' ⚠ กรุณาเลือก'}
      </Typography>
      <Stack spacing={0}>
        {options.map((opt) => {
          const selected = currentKey === opt.key;
          const disabledReason = getOptionDisabledReason?.(opt, { selected, currentKey }) || '';
          const disabled = Boolean(disabledReason);
          const optionNode = (
            <Box
              key={opt.key}
              onClick={() => {
                if (disabled) return;
                onSelect(selected ? '' : opt.key);
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.6,
                py: 0.1,
                px: 0.5,
                borderRadius: 1,
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.55 : 1,
                bgcolor: selected ? `${opt.color}18` : 'transparent',
                '&:hover': { bgcolor: disabled ? 'transparent' : `${opt.color}10` },
              }}
            >
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  flexShrink: 0,
                  border: '2px solid',
                  borderColor: selected ? opt.color : '#cbd5e1',
                  bgcolor: selected ? opt.color : 'transparent',
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  fontSize: '0.72rem',
                  color: selected ? opt.color : 'text.primary',
                  fontWeight: selected ? 700 : 400,
                }}
              >
                {opt.label}
              </Typography>
            </Box>
          );

          if (disabled) {
            return (
              <Tooltip key={opt.key} title={disabledReason} placement="top">
                <Box component="span" sx={{ display: 'block' }}>
                  {optionNode}
                </Box>
              </Tooltip>
            );
          }

          return (
            <React.Fragment key={opt.key}>{optionNode}</React.Fragment>
          );
        })}
      </Stack>
    </Box>
  );
}
